import React, { createContext, useContext, useEffect, useState } from "react";

const QuoteContext = createContext(null);
const KEY = "molar_quote_list";

export function QuoteProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; }
  });
  const [freeRequests, setFreeRequests] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY + "_free")) || []; } catch { return []; }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => { localStorage.setItem(KEY, JSON.stringify(items)); }, [items]);
  useEffect(() => { localStorage.setItem(KEY + "_free", JSON.stringify(freeRequests)); }, [freeRequests]);

  const addItem = (product, qty = 1) => {
    setItems((prev) => {
      const idx = prev.findIndex((p) => p.urun_id === product.urun_id);
      if (idx >= 0) {
        const copy = [...prev];
        copy[idx] = { ...copy[idx], adet: copy[idx].adet + qty };
        return copy;
      }
      return [...prev, {
        urun_id: product.urun_id, urun_kodu: product.urun_kodu || "",
        urun_adi: product.urun_adi_tr || "", marka: product.marka || "",
        ambalaj: product.ambalaj || "", ambalaj_miktari: product.ambalaj_miktari ?? null,
        ambalaj_birimi: product.ambalaj_birimi || "", satis_uygunlugu: product.satis_uygunlugu || "bireysel",
        adet: qty, musteri_notu: "",
      }];
    });
    setOpen(true);
  };
  const updateItem = (urun_id, patch) =>
    setItems((prev) => prev.map((p) => (p.urun_id === urun_id ? { ...p, ...patch } : p)));
  const removeItem = (urun_id) => setItems((prev) => prev.filter((p) => p.urun_id !== urun_id));
  const clear = () => { setItems([]); setFreeRequests([]); };
  const addFree = (metin) => setFreeRequests((prev) => [...prev, metin]);
  const removeFree = (i) => setFreeRequests((prev) => prev.filter((_, idx) => idx !== i));

  // Kalem = farklı ürün/ambalaj satırı; ambalaj = talep edilen toplam ambalaj adedi
  const kalemCount = items.length;
  const ambalajCount = items.reduce((a, p) => a + p.adet, 0);

  return (
    <QuoteContext.Provider value={{ items, freeRequests, open, setOpen, addItem,
      updateItem, removeItem, clear, addFree, removeFree, kalemCount, ambalajCount }}>
      {children}
    </QuoteContext.Provider>
  );
}

export const useQuote = () => useContext(QuoteContext);
